/**
 * Unlocked Content Remapper
 * Flutter: lib/data/models/unlocked_content.dart
 *
 * Converts between UnlockedContentDto (Firestore) and UnlockedContentStorage (IndexedDB).
 */
import type { UnlockedContentDto } from '@/data/dtos/unlockedContent/unlockedContentDto';
import type { JsonObject } from '@/data/types/json';
import type { UnlockedContentStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class UnlockedContentRemapper {
  static toStorage(dto: UnlockedContentDto): UnlockedContentStorage {
    return {
      path: dto.path,
      timestamp: dto.timestamp,
    };
  }

  static fromJson(data: JsonObject): UnlockedContentDto {
    return {
      path: (data['path'] as string | undefined) ?? '',
      timestamp: (data['timestamp'] as number | undefined) ?? 0,
    };
  }

  static fromJsonList(dataList: JsonObject[]): UnlockedContentDto[] {
    return dataList.map(UnlockedContentRemapper.fromJson);
  }
}
